import React from 'react'
import {SystemStyleObject} from '@chakra-ui/react'
import {Picture} from '_uiComponents'
import {updateCloudinaryPDImage} from '_utils'
import {usePageDesigner} from '_customHooks'
import {CLDImageAsset} from '_types'

interface ImageItemProps {
    imageDesktop: CLDImageAsset
    imageTablet: CLDImageAsset
    imageMobile: CLDImageAsset
    imageTitle?: string
    styles?: SystemStyleObject
}

const ImageItem: React.FC<ImageItemProps> = ({imageDesktop, imageTablet, imageMobile, imageTitle, styles}) => {
    const {globalImageTransformation, CloudinaryPageDesignerCNAME} = usePageDesigner()

    const resizedImgMobile = imageMobile ? updateCloudinaryPDImage(imageMobile, globalImageTransformation, CloudinaryPageDesignerCNAME) : ''
    const resizedImgTablet = imageTablet ? updateCloudinaryPDImage(imageTablet, globalImageTransformation, CloudinaryPageDesignerCNAME) : ''
    const resizedImgDesk = imageDesktop ? updateCloudinaryPDImage(imageDesktop, globalImageTransformation, CloudinaryPageDesignerCNAME) : ''
    const resizedImgXlDesk = imageDesktop ? updateCloudinaryPDImage(imageDesktop, globalImageTransformation, CloudinaryPageDesignerCNAME) : ''

    return (
        <Picture
            className="cc-image-item"
            overflow="hidden"
            objectFit="cover"
            imagexs={resizedImgMobile}
            imagesm={resizedImgTablet || resizedImgDesk}
            imagelg={resizedImgDesk}
            imagexl={resizedImgXlDesk}
            alt={imageTitle}
            hasLazy={true}
            sx={styles}
        />
    )
}

export {ImageItem}
